var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.colorDataExists && _vm.colorData.length > 1
    ? _c(
        "div",
        { staticClass: "variation-colors" },
        [
          _vm._l(_vm.colorData, function (color, index) {
            return [
              index < 8
                ? _c("div", { key: index, staticClass: "variation-color" }, [
                    _c(
                      "a",
                      { attrs: { href: _vm.itemUrl } },
                      [
                        color.description.startsWith("#")
                          ? [
                              _c("div", {
                                staticClass: "variation-color-thumb",
                                style: "background-color:" + color.description,
                                attrs: {
                                  title: color.value,
                                  "aria-label": color.value,
                                },
                              }),
                            ]
                          : [
                              _c("img", {
                                staticClass: "variation-color-thumb",
                                attrs: {
                                  src:
                                    "https://images.bundeswehr-und-mehr.de/frontend/colors/" +
                                    color.description,
                                  alt: color.value,
                                  title: color.value,
                                  loading: "lazy",
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "more-colors-link-container" }, [
            _c(
              "a",
              { staticClass: "more-colors-link", attrs: { href: _vm.itemUrl } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ecomsilio::Template.moreColors", {
                      count: _vm.colorData.length,
                    })
                  )
                ),
              ]
            ),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }